import React, { useState } from "react";
import { verifyPermission } from "../../services/auth";
import { CreateMarketingDto } from "../../models/dtos/createMarketing";
import ModalNewTutorial from "../ModalNewTutorial";

import { Button, AddIcon } from "./styles";

interface IProps {
  handleAdd: (
    marketing: CreateMarketingDto
  ) => Promise<{ success: boolean; error: string }>;
}

const ButtonAddNewTutorial: React.FC<IProps> = ({ handleAdd }) => {
  const [isVisible, setIsVisible] = useState(false);
  const openModal = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <>
      {verifyPermission("marketing.add_new") && (
        <Button id="newMarketing-button" onClick={openModal}>
          <AddIcon />
          <span>Adicionar Novo</span>
        </Button>
      )}
      <ModalNewTutorial
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        handleAdd={handleAdd}
      />
    </>
  );
};

export default ButtonAddNewTutorial;
